// src/shared/components/PerlAddButton.jsx
import React from "react";
import { IconButton, alpha } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { theme } from "../../design/theme";

const perlColors = theme.custom.perlColors;

/**
 * Circular add button styled with PERL theme colors.
 * Usage:
 *  <PerlAddButton onClick={handleAdd} />
 */
export default function PerlAddButton({ sx = {}, ...props }) {
  return (
    <IconButton
      aria-label="add"
      {...props}
      sx={{
        width: 40,
        height: 40,
        borderRadius: "50%",
        border: `2px solid ${perlColors.border}`,
        bgcolor: alpha(perlColors.white, 0.06),
        color: perlColors.textPrimary,
        transition: "all 0.2s ease",
        "&:hover": {
          bgcolor: alpha(perlColors.brandColor, 0.16),
          borderColor: perlColors.brandColor,
        },
        "&:active": {
          bgcolor: alpha(perlColors.brandColor, 0.24),
        },
        ...sx,
      }}
    >
      <AddIcon />
    </IconButton>
  );
}

